var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-view',{staticClass:"back-btn",on:{"click":_vm.toMainPage}},[_c('div',[_c('img',{attrs:{"src":require('@/assets/icons/arrow-back.svg'),"alt":_vm.$t('back')}})]),_c('span',[_vm._v(_vm._s(_vm.$t('back')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }